<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("edit") }} {{ $tc("Ticket Type", 2) }}
      </div>
      <div>
        <router-link class="btn-blue" to="ticket-type"
          >{{ $tc("Ticket Type", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in TicketTypes"
          :key="index"
          v-if="item.fieldname !== 'tt_id'"
          class="col-lg-6 col-xl-4 align-self-center"
        >
          <div v-if="item.fieldname !== 'tt_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">
                {{ $tc(item.errormsg) }}
              </span>
            </p>
          </div>
          <div v-if="item.fieldname === 'tt_is_active'">
            <div class="row">
              <div class="col-md-3 col-xl-2 align-self-center">
                <label class="mb-0">{{ $t("active") }}</label>
              </div>
              <div class="col-md-9 col-xl-10 align-self-center">
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox mb-0 ml-2"
                  v-model="item.fieldvalue"
                />
              </div>
            </div>
            <p class="error_message"></p>
          </div>
        </div>

        <div class="col-12">
          <TranslationsContainer :translationsObj="translationsObj" />
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="resetHandler"
            class="btn-black"
          >
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="ticket-type"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import TicketTypes from "@/helper/formJSONMaster/TicketTypes";
import TranslationsContainer from "@/components/Partials/translationsFields.vue";

export default {
  components: {
    TranslationsContainer,
  },
  data() {
    return {
      btenable: false,
      Methods: TicketTypes.Methods,
      TicketTypes: TicketTypes.ms_ticket_types,
      submitted: false,
      translationsObj: {},
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    console.log("id :", id);
    if (id) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.TicketTypes.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    getEditList: function (id) {
      MasterService.GetTicketTicketTypeById({ tt_id: id })
        .then((response) => {
          console.log("fromresponse", response);
          const { data } = response;
          if (data.status) {
            console.log("data :", data);
            let obj = data.Records[0];
            this.TicketTypes.map((x) => {
              if (x.fieldname === "tt_is_active") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
                console.log(this.TicketTypes);
              }
            });

            if (obj.translationsObj) {
              this.translationsObj = obj.translationsObj;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(data.error);
        });
    },
    onUpdateHandler: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;

          console.log("valid :", valid);
          let body = this.getRequestBody("PUT", this.TicketTypes, {
            ...this.Methods,
            params: { id: this.$route.query.id },
          });

          body.payload = {
            ...body.payload,
            translationsObj: this.translationsObj,
          };

          console.log("body :", body);

          MasterService.EditTicketTicketType(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;

              if (data.status) {
                console.log("here :", data);
                this.$router.push({
                  path: "ticket-type",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((error) => {
              this.$toasted.show(data.error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TicketType/editTicketType.vue